import React from 'react';

export const Cube3dFilled = () => (
    <>
        <path className='st0' d='M4,8V6c0-1.1,0.9-2,2-2h2' />
        <path className='st0' d='M4,16v2c0,1.1,0.9,2,2,2h2' />
        <path className='st0' d='M16,4h2c1.1,0,2,0.9,2,2v2' />
        <path className='st0' d='M16,20h2c1.1,0,2-0.9,2-2v-2' />
        <path d='M6.6,9.2l5.4,3.4l0,0c1.8-1.1,3.7-2.3,5.4-3.4l0,0L12,5.8L6.6,9.2z' strokeWidth='0' fill='#80d6fb' />
        <path d='M12,12.6v6.1l5.4-3.4V9.2C15.7,10.3,13.8,11.5,12,12.6z' strokeWidth='0' fill='#466089' />
        <path d='M12,12.6L12,12.6v6.1l-5.4-3.4V9.2l0,0C8.3,10.3,10.2,11.5,12,12.6z' strokeWidth='0' fill='#6e83b7' />
    </>
);